export const TEST_RIDE_DATA_ID = 'home_test-ride';
export const TEST_RIDE_MAX_CARD = 4;
